import { render, staticRenderFns } from "./SfPagination.vue?vue&type=template&id=6787953a&"
import script from "./SfPagination.vue?vue&type=script&lang=js&"
export * from "./SfPagination.vue?vue&type=script&lang=js&"
import style0 from "./SfPagination.vue?vue&type=style&index=0&id=6787953a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports